export default __webpack_public_path__ + "static/media/Asset 15.3ee27d52.svg";